// src/utils/agruparPorMes.js

export function agruparPorMes(parcelas) {
  return parcelas.reduce((acc, p) => {
    const rawDate = p.dataVencimento || p.dataPagamento;
    const data = new Date(rawDate);

    // 🔒 proteção contra data inválida
    if (isNaN(data.getTime())) return acc;

    const mes = data.toISOString().slice(0, 7);

    if (!acc[mes]) acc[mes] = [];
    acc[mes].push(p);

    return acc;
  }, {});
}